module.exports = require("@wildboar/x500/src/lib/modules/IDMProtocolSpecification/Error.ta");